export default __webpack_public_path__ + "77e2e5302fecb98f05de0059543c735c.png";